import React from 'react'

import Dialog from 'components_new/atoms/Dialog'
import DialogTitle from 'components_new/atoms/Dialog/DialogTitle'
import DialogContent from 'components_new/atoms/Dialog/DialogContent'
import DialogActions from 'components_new/atoms/Dialog/DialogActions'
import Divider from 'components_new/atoms/Divider'
import Text from 'components_new/atoms/Text'

const Modal = (props) => {
  const {
    header,
    visible,
    children,
    actions,
    size,
    onClose,
    subHeader,
    footerClassName = '',
    customHeader,
    zIndex = 1400
  } = props

  // medium
  let width = 'md'

  if (size === 'large') {
    width = 'lg'
  } else if (size === 'small') {
    width = 'sm'
  }

  return (
    <Dialog
      sx={{ width: '100%', zIndex }}
      maxWidth={width}
      open={visible}
      onClose={onClose}
      className={'ignore-locked-mode'}
    >
      {customHeader || header ? (
        <DialogTitle sx={{ p: 2 }}>
          {customHeader ? (
            customHeader
          ) : (
            <>
              <Text variant="body1">{header}</Text>
              {subHeader ? <Text variant="body2">{subHeader}</Text> : null}
            </>
          )}
        </DialogTitle>
      ) : null}
      <DialogContent sx={{ p: 2 }}>{children}</DialogContent>
      {actions && (
        <>
          <Divider sx={{ mt: 2 }} />
          <DialogActions
            sx={{
              p: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 1
            }}
            className={footerClassName}
          >
            {actions}
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default Modal
